"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const react_1 = __importDefault(require("react"));
const useInheritedStyles_1 = require("../../../hooks/useInheritedStyles");
const Box_1 = require("../../Box");
const ThemeContext_1 = require("../../Theme/ThemeContext");
const Text = (props) => {
    const { as = "span", children, size, sx = {}, variant } = props;
    const themeContext = react_1.default.useContext(ThemeContext_1.ThemeContext);
    const getFontSize = (textSize) => {
        switch (textSize) {
            case "9xl":
                return 12;
            case "8xl":
                return 11;
            case "7xl":
                return 10;
            case "6xl":
                return 9;
            case "5xl":
                return 8;
            case "4xl":
                return 7;
            case "3xl":
                return 6;
            case "2xl":
                return 5;
            case "xl":
                return 4;
            case "lg":
                return 3;
            case "md":
                return 2;
            case "sm":
                return 1;
            case "xs":
                return 0;
            default:
                return;
        }
    };
    const fontSize = react_1.default.useMemo(() => {
        if (Array.isArray(size)) {
            return size.map(getFontSize);
        }
        else {
            return getFontSize(size);
        }
    }, [size]);
    sx.fontSize = fontSize !== undefined ? fontSize : sx.fontSize;
    sx.lineHeight = fontSize !== undefined ? fontSize : sx.lineHeight;
    sx.fontWeight = variant || sx.fontWeight;
    const { newInheritedStylesContext, mergedSx } = (0, useInheritedStyles_1.useMergeStyles)(sx);
    // Setting up default <Text> lineHight, fontWeight, textRendering properties - have to check lineHeight against undefined because it can be 0 (falsy value)
    if (newInheritedStylesContext.lineHeight === undefined &&
        mergedSx.lineHeight === undefined) {
        newInheritedStylesContext.lineHeight = 2;
        mergedSx.lineHeight = 2;
    }
    if (!newInheritedStylesContext.fontWeight && !mergedSx.fontWeight) {
        newInheritedStylesContext.fontWeight = "regular";
        mergedSx.fontWeight = "regular";
    }
    if (!newInheritedStylesContext.textRendering && !mergedSx.textRendering) {
        newInheritedStylesContext.textRendering = "optimizeLegibility";
        mergedSx.textRendering = "optimizeLegibility";
    }
    // TODO remove conditional logic when upgrading to next major release (v3 / v4 ?) --> should always wrap box in IneritedStylesProvider -EO
    if (themeContext.usingStyleInheritance) {
        return (react_1.default.createElement(useInheritedStyles_1.InheritedStylesProvider, { styleContext: newInheritedStylesContext },
            react_1.default.createElement(Box_1.Box, Object.assign({}, props, { as: as, sx: mergedSx }), children)));
    }
    else {
        return (react_1.default.createElement(Box_1.Box, Object.assign({}, props, { as: as, sx: Object.assign({ color: "text01", fontFamily: "body", fontSize: fontSize || 2, fontWeight: variant || "regular", lineHeight: fontSize || 2, textRendering: "optimizeLegibility" }, sx) }), children));
    }
};
exports.Text = Text;
//# sourceMappingURL=Text.js.map